import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { PolicyService } from '../api/policy.service';
import { PoliceViewList } from '../models/policy.models';

export const policiesResolver: ResolveFn<PoliceViewList[]> = async () => {
    const policyService = inject(PolicyService);
    const policies = policyService.policies();

    if (policies.length === 0) {
        return await lastValueFrom(policyService.getAll());
    }
    return policies;
};
